/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M21.943 11.9888c-.9524 1.1939-2.3509 2.0162-3.943 2.2148V24l-8.25-4.5L1.5 24V3l.0004-.0504A3.0318 3.0318 0 0 1 1.5148 2.7l.0022-.0209c.0826-.7774.4622-1.466 1.0231-1.9505A2.9883 2.9883 0 0 1 4.5 0H15l.0504.0004c.0841.0014.1673.0062.2496.0144l.0209.0022c1.0442.111 1.9284.7577 2.3724 1.6601.0947.1924.1694.3964.2213.6093.0319.0035.0637.0073.0955.0113 1.586.2005 2.9791 1.0202 3.9294 2.2092M4.5 1.5c-.7692 0-1.4033.579-1.49 1.325L3 3v18.4725l6.75-3.6811 6.75 3.6826v-7.2704c-1.5921-.1986-2.9906-1.0209-3.943-2.2148A5.9747 5.9747 0 0 1 11.25 8.25c0-.1067.0028-.2127.0083-.318.0676-1.2948.5457-2.4809 1.3066-3.4306A6.028 6.028 0 0 1 14.343 3 5.9726 5.9726 0 0 1 15 2.6861l.0402-.016a5.957 5.957 0 0 1 1.2967-.351c-.223-.4369-.6537-.75-1.162-.809L15 1.5H4.5Zm9.6834 3.4566A4.486 4.486 0 0 1 17.25 3.75c.2555 0 .5061.0213.75.0622 2.1283.357 3.75 2.208 3.75 4.4378 0 2.2297-1.6217 4.0807-3.75 4.4378a4.5328 4.5328 0 0 1-.75.0622 4.5328 4.5328 0 0 1-.75-.0622c-1.0658-.1788-2.0046-.7323-2.6763-1.5204A4.482 4.482 0 0 1 12.75 8.25a4.4814 4.4814 0 0 1 1.1546-3.0098 4.5483 4.5483 0 0 1 .2788-.2835Zm7.7596 7.0322a5.9687 5.9687 0 0 0 1.2886-3.2657 6.0717 6.0717 0 0 0 .0121-.7504 5.9697 5.9697 0 0 0-1.2539-3.402c-.0107-.0139-.0216-.0277-.0324-.0414a16.7316 16.7316 0 0 0-.0156-.0195"
    clipRule="evenodd"
  />,
  'Bookmark'
);
